export const numbersTabs = [
    {
        link: '/numbers',
        name: 'Numbers'
    },
    {
        link: '/numbers/charge-groups',
        name: 'Number Charge Groups'
    },
    {
        link: '/numbers/pools',
        name: 'Number Pools'
    }
];
